import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Br, Cashdraw, Cut, Line, Printer, Text, render } from "react-thermal-printer";
import {
  getOrderDetails,
  getPrinterConfig,
  getPrinterIds,
  getRetailDetailsByBranch,
  returnItemDetails,
} from "../../../../config/Services";
import { getFromLocalStorage, setInLocalStorage } from "../../../../utils/localStorageHelpers";
import { eventTrackerConstant } from "../../../common/event-tracker/event-tracker-constants";
import { eventTracker } from "../../../common/event-tracker/eventTracker";
import { convertToLocalDateTime } from "../all-products/Middleware/commonUtils";
import {
  renderPicklist,
  renderReport,
  renderProduct,
  renderTemplate001,
  renderTemplate002,
  renderTemplate003,
  renderTemplate004,
  renderTemplate005,
  renderTemplate006,
  renderTemplate007,
  renderTokenStandalone,
  renderTemplate008,
  renderTemplate001_01,
  renderTemplate002_02,
  renderTemplate002_01,
  renderCreditSettlement,
} from "../all-products/print/utils/templateRenderer";
import { setUSBDevice } from "../all-products/redux/Actions/printingDeviceActions";
import { setLabelPrinterDevice } from "../all-products/redux/Actions/labelPrinterDeviceActions";
import { useSnackbar } from "./SnackbarProvider";
import { getDeviceType, getMobilePos } from "../all-products/redux/Reducers/paginationReducer";
import { emit, useNativeMessage } from "react-native-react-bridge/lib/web";
import { setBluetoothDevice } from "../all-products/redux/Actions/bluetootDeviceActions";
import { UserContext } from "../../../../App";

const usePrint = () => {
  const showSnackbar = useSnackbar();
  const [isPrinting, setIsPrinting] = useState(false);
  const [isError, setIsError] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [reprint, setReprint] = useState(false);
  const [cashDrawerOpen, setCashDrawerOpen] = useState(false);
  const [orderSource, setOrderSource] = useState("pos");
  const [printType, setPrintType] = useState("invoice");
  const [pickerName, setPickerName] = useState("");
  const [skipBill, setSkipBill] = useState(false);
  const [skipKot, setSkipKot] = useState(false);
  const [forcePickDevice, setForcePickDevice] = useState(false);
  const [key, setKey] = useState(0);
  const deviceType = useSelector(getDeviceType);
  const [orderId, setOrderId] = useState("");
  const [baseOrderResponse, setBaseOrderResponse] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [baseDetails, setBaseDetails] = useState({});
  const [deliveryAddress, setDeliveryAddress] = useState({});
  const [orderTokenDetails, setOrderTokenDetails] = useState({});
  const [gstBreakupDetails, setGstBreakupDetails] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [freeProducts, setFreeProducts] = useState([]);
  const [sessionData, setSessionData] = useState(null);
  const [productData, setProductData] = useState(null);
  const [settlementData, setSettlementData] = useState(null);
  const [noGst, setNoGst] = useState([]);
  const [gst1slab, setGst1slab] = useState([]);
  const [gst2slab, setGst2slab] = useState([]);
  const [gst5slab, setGst5slab] = useState([]);
  const [gst6slab, setGst6slab] = useState([]);
  const [gst9slab, setGst9slab] = useState([]);
  const [gst14slab, setGst14slab] = useState([]);
  const [gst20slab, setGst20slab] = useState([]);
  const [cessItems, setCessItems] = useState([]);
  const [date, setDate] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [retailDetails, setRetailDetails] = useState([]);
  const dispatch = useDispatch();
  let usbDevice = useSelector((state) => state.printing);
  let labelPrinterDevice = useSelector((state) => state.labelPrinting);
  let bluetoothDevice = useSelector((state) => state.bluetoothPrinting);
  const [returnId, setReturnId] = useState([]);
  const [tokenNumber, setTokenNumber] = useState("");
  const { saleMode } = useContext(UserContext);
  const branchSubType = localStorage.getItem("branchSubType");

  const [locationData, setLocationData] = useState(
    JSON.parse(localStorage.getItem("locationData"))
  );

  const storedOrgConfig = JSON.parse(localStorage.getItem("orgConfig")) || {};
  const [isTokenPrinting, setIsTokenPrinting] = useState(false);

  const [printerWidth, setPrinterWidth] = useState(storedOrgConfig.charactersPerLine ?? 42);
  const [orgConfig, setOrgConfig] = useState(storedOrgConfig);

  const [printerConfig, setPrinterConfig] = useState(
    JSON.parse(localStorage.getItem("printerConfig"))
  );

  const getStoredRetailDetails = () => {
    const storedLocationData = getFromLocalStorage("locationData", null);
    const details = storedLocationData || locationData || retailDetails;
    const locName = localStorage.getItem("LocName");

    if (!details || Array.isArray(details) || typeof details !== "object") {
      return locName ? { displayName: locName } : {};
    }

    const address =
      details.address ||
      details.addresses?.find((addr) => addr?.defaultAddress || addr?.defaultBilling) ||
      details.addresses?.[0] ||
      {};
    const contacts = Array.isArray(details.contacts) ? details.contacts : [];
    const addressPhone = address?.phoneNo || address?.mobileNumber;

    return {
      ...details,
      displayName: details?.displayName || details?.name || locName,
      address,
      contacts: contacts?.length || !addressPhone ? contacts : [{ phoneNo: addressPhone }],
    };
  };

  // Initialize on mount - try to restore saved printer from localStorage
  useEffect(() => {
    const restoreSavedPrinter = async () => {
      if (!usbDevice) {
        const savedPrinterInfo = localStorage.getItem("savedUSBPrinterDevice");
        if (savedPrinterInfo) {
          try {
            const { vendorId, productId } = JSON.parse(savedPrinterInfo);
            // Try to get the already-paired device
            const devices = await navigator.usb.getDevices();
            const savedDevice = devices.find(
              (d) => d.vendorId === vendorId && d.productId === productId
            );
            if (savedDevice) {
              dispatch(setUSBDevice(savedDevice));
            }
          } catch (error) {
          }
        }
      }
    };
    restoreSavedPrinter();
  }, []);

  const isB2cOrder = orderSource === "b2c";
  const isDeliveryOrder = orderSource === "delivery";
  const isReport = printType === "report";
  const isEndReport = printType === "end-report";
  const fetchDetails = async (type, orderId, returnId = null) => {
    if (drawerOpen || isReport || isEndReport) {
      setKey((prevKey) => prevKey + 1);
      return;
    }

    setCashDrawerOpen(false);

    const rtBrId = localStorage.getItem("locId");

    try {
      if (type === "credit-settlement") {
        setDate(convertToLocalDateTime(new Date()) || "N/A");
      } else {
        let response;
        if (type === "credit-note") {
          response = await returnItemDetails(returnId, orderId);
        } else {
          response = await getOrderDetails(orderId, rtBrId);
        }

        const data = response?.data?.data;
        // Set common states
        setBaseOrderResponse(data?.baseOrderResponse || data?.baseReturnResponse);
        setDeliveryAddress(data?.addressEntityModel?.shippingAddress);
        setDate(
          convertToLocalDateTime(
            data?.baseOrderResponse?.createdAt || data?.baseReturnResponse?.createdAt
          ) || "N/A"
        );
        setInvoiceId(data?.baseOrderResponse?.invoiceId || data?.baseReturnResponse?.invoiceId);
        setBaseDetails(data?.orderBillingDetails || data?.returnBillingDetails);
        setGstBreakupDetails(data?.gstBreakupDetails);
        setFreeProducts(data?.freeProducts);
        setOrderTokenDetails(data?.orderTokenDetails);
        // Sort items like the cart (latest modified on top) so the bill matches the cart order.
        // Only for non-restaurant (grocery) — RESTAURANT keeps the server order.
        const isRestaurant = localStorage.getItem("retailType") === "RESTAURANT";
        const sortLikeCart = (items) =>
          isRestaurant
            ? items || []
            : [...(items || [])].sort((a, b) =>
                (b?.modifiedDate || "").localeCompare(a?.modifiedDate || "")
              );
        setOrderItems(
          sortLikeCart(
            data?.baseOrderResponse?.orderItemList || data?.baseReturnResponse?.returnedItems
          )
        );
        setTotalQuantity(
          (data?.baseOrderResponse?.orderItemList || data?.baseReturnResponse?.returnedItems || [])
            ?.filter((item) => item?.voidStatus == null)
            ?.map((item) => item?.quantity)
            ?.reduce((a, b) => a + b, 0)
        );

        // Set GST states
        const gstWiseOrderItems = data?.gstWiseOrderItems || {};
        setNoGst(sortLikeCart(gstWiseOrderItems["No Gst slab"]));
        setGst1slab(sortLikeCart(gstWiseOrderItems["1.5 cgst and 1.5 sgst slab"]));
        setGst2slab(sortLikeCart(gstWiseOrderItems["2.5 cgst and 2.5 sgst slab"]));
        setGst5slab(sortLikeCart(gstWiseOrderItems["5 cgst and 5 sgst slab"]));
        setGst6slab(sortLikeCart(gstWiseOrderItems["6 cgst and 6 sgst slab"]));
        setGst9slab(sortLikeCart(gstWiseOrderItems["9 cgst and 9 sgst slab"]));
        setGst14slab(sortLikeCart(gstWiseOrderItems["14 cgst and 14 sgst slab"]));
        setGst20slab(sortLikeCart(gstWiseOrderItems["20 cgst and 20 sgst slab"]));
        setCessItems(data?.cessBreakUpDetails || []);
        setTokenNumber(data?.orderTokenDetails?.token || "");

        const payments =
          data?.orderBillingDetails?.payments || data?.returnBillingDetails?.refunds;
        const isCashOrSodexoPayment = payments?.some(
          (payment) =>
            payment?.paymentMethod === "CASH" ||
            payment?.paymentMethod === "SODEXO" ||
            payment?.refundMode === "CASH" ||
            payment?.refundMode === "SODEXO"
        );

        if (isCashOrSodexoPayment && !reprint) {
          setCashDrawerOpen(true);
        }
      }

      let locationDetails = {};
      if (!locationData) {
        try {
          const response = await getRetailDetailsByBranch(rtBrId);
          if (response?.data?.data) {
            localStorage.setItem("locationData", JSON.stringify(response?.data?.data));
            locationDetails = response.data.data;
          }
        } catch (e) {}
      } else {
        locationDetails = locationData;
      }
      setRetailDetails(locationDetails);
    } catch (error) {
      // showSnackbar(error?.response?.data?.message, "error");
    }

    const orgConfig = getFromLocalStorage("orgConfig");
    if (orgConfig) {
      setOrgConfig(orgConfig);
    } else {
      try {
        const orgId = localStorage.getItem("orgId");
        const response = await getPrinterConfig(orgId);
        if (!!response?.data?.es) {
          throw new Error(response?.data?.message);
        }
        setOrgConfig(response?.data?.configuration);
        setInLocalStorage("orgConfig", response?.data?.configuration);
      } catch (error) {
        console.log(error);
      }
    }

    setKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    if (orgConfig?.charactersPerLine) {
      setPrinterWidth(orgConfig.charactersPerLine);
    }
  }, [orgConfig]);

  const fetchUrlToBase64 = async (url, maxWidth = 200) => {
    if (!url) return null;

    // Check cache first
    const cacheKey = `logo_base64_${url}_${maxWidth}`;
    const cachedLogo = localStorage.getItem(cacheKey);

    if (cachedLogo) {
      return cachedLogo;
    }

    // If not cached, fetch and cache it
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const img = await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = reject;
        image.src = URL.createObjectURL(blob);
      });

      // Resize if necessary
      const canvas = document.createElement("canvas");
      const scale = maxWidth / img.width;
      canvas.width = maxWidth;
      canvas.height = img.height * scale;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      const base64 = canvas.toDataURL("image/png");

      // Store in cache
      localStorage.setItem(cacheKey, base64);

      return base64;
    } catch (err) {
      console.error("Error fetching logo:", err);
      return null;
    }
  };

  const printToken = async (tokenData) => {
    const {
      tableId,
      tokenNumber,
      tableNumber,
      subOrderType,
      customerName,
      orderItems,
      comments,
      layoutName,
      startTime,
      endTime,
      slotId
    } = tokenData;

    try {
      // Generate print data using renderToken
      const tokenPrintData = await renderTokenStandalone({
        tableId,
        tokenNumber,
        tableNumber,
        subOrderType,
        customerName,
        orderItems,
        printerWidth,
        saleMode,
        comments,
        layoutName,
        startTime,
        endTime,
        slotId
      });

      // Resolve device the same way as printUSB
      let deviceToUse = usbDevice;
      // Tracks whether the device was chosen via the picker in this call. A cached
      // device that fails to write gets a reselect-on-failure retry; a freshly picked
      // one does not (the user just picked it).
      let pickedFromPicker = false;
      if (!deviceToUse) {
        try {
          const savedPrinterInfo = localStorage.getItem("savedUSBPrinterDevice");
          if (savedPrinterInfo) {
            const { vendorId, productId } = JSON.parse(savedPrinterInfo);
            const devices = await navigator.usb.getDevices();
            deviceToUse = devices.find((d) => d.vendorId === vendorId && d.productId === productId);
            if (deviceToUse) dispatch(setUSBDevice(deviceToUse));
          }
        } catch (_) {}
      }
      if (!deviceToUse) {
        deviceToUse = await pickUSBDevice();
        pickedFromPicker = true;
      }
      usbDevice = deviceToUse;

      try {
        await writeToUSBDevice(deviceToUse, tokenPrintData);
      } catch (writeError) {
        // The write failed. If we were using a cached device (not one the user just
        // picked), it most likely got disconnected. Forget it and re-open the picker
        // so the user can reconnect / reselect a printer, then retry once.
        if (pickedFromPicker) throw writeError;
        clearUSBDevice();
        deviceToUse = await pickUSBDevice();
        usbDevice = deviceToUse;
        await writeToUSBDevice(deviceToUse, tokenPrintData);
      }
    } catch (error) {
      setIsError(true);
      throw error;
    }
  };

  const renderPrintContents = async () => {
    const logoUrl = localStorage.getItem("logoUrl");
    const imgBase64 = await fetchUrlToBase64(logoUrl);
    const retailType = localStorage.getItem("retailType");
    let renderData = null;
    if (retailType === "RESTAURANT") {
      if (orgConfig?.templateId === "template_007") {
        renderData = await renderTemplate007({
          printerWidth,
          retailDetails,
          baseOrderResponse,
          baseDetails,
          gstBreakupDetails,
          imgBase64,
          cessItems,
          noGst,
          gst2slab,
          gst1slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          gst20slab,
          freeProducts,
          isB2cOrder,
          isDeliveryOrder,
          reprint,
          orderId,
          invoiceId,
          date,
          totalQuantity,
          orgConfig,
          deliveryAddress,
          cashDrawerOpen,
          returnId,
          printType,
          tokenNumber,
          saleMode,
          branchSubType,
          skipBill,
          skipKot,
        });
      } else if (orgConfig?.templateId === "template_008") {
        renderData = await renderTemplate008({
          printerWidth,
          retailDetails,
          baseOrderResponse,
          baseDetails,
          gstBreakupDetails,
          imgBase64,
          cessItems,
          noGst,
          gst2slab,
          gst1slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          gst20slab,
          freeProducts,
          isB2cOrder,
          isDeliveryOrder,
          reprint,
          orderId,
          invoiceId,
          date,
          totalQuantity,
          orgConfig,
          deliveryAddress,
          cashDrawerOpen,
          returnId,
          printType,
          tokenNumber,
          saleMode,
          branchSubType,
          skipBill,
          skipKot,
        });
      } else {
        renderData = await renderTemplate006({
          printerWidth,
          retailDetails,
          baseOrderResponse,
          baseDetails,
          gstBreakupDetails,
          imgBase64,
          cessItems,
          noGst,
          gst2slab,
          gst1slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          gst20slab,
          freeProducts,
          isB2cOrder,
          isDeliveryOrder,
          reprint,
          orderId,
          invoiceId,
          date,
          totalQuantity,
          orgConfig,
          deliveryAddress,
          cashDrawerOpen,
          returnId,
          printType,
          tokenNumber,
          saleMode,
          branchSubType,
          skipBill,
          skipKot,
        });
      }
    } else {
      switch (orgConfig?.templateId) {
        case "template_001":
          renderData = await renderTemplate001({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;

        case "template_001_1":
          renderData = await renderTemplate001_01({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;

        case "template_001_02":
          renderData = await renderTemplate002_02({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;

        case "template_002":
          renderData = await renderTemplate002({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            orderItems,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;
        case "template_002_01":
          renderData = await renderTemplate002_01({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            orderItems,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;
        case "template_003":
          renderData = await renderTemplate003({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            cessItems,
            orderItems,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;
        case "template_004":
          renderData = await renderTemplate004({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;
        case "template_005":
          renderData = await renderTemplate005({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            noGst,
            gst2slab,
            gst1slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
          break;
        default:
          renderData = await renderTemplate001({
            printerWidth,
            retailDetails,
            baseOrderResponse,
            baseDetails,
            gstBreakupDetails,
            cessItems,
            noGst,
            gst1slab,
            gst2slab,
            gst5slab,
            gst6slab,
            gst9slab,
            gst14slab,
            gst20slab,
            freeProducts,
            isB2cOrder,
            isDeliveryOrder,
            reprint,
            orderId,
            invoiceId,
            date,
            totalQuantity,
            orgConfig,
            deliveryAddress,
            cashDrawerOpen,
            returnId,
            printType,
            saleMode,
            tokenNumber,
          });
      }
    }

    return await render(renderData);
  };

  const billData = async (drawerOpen) => {
    if (drawerOpen) {
      return await render(
        <Printer type="epson" width={printerWidth}>
          <Cashdraw pin="2pin" />
        </Printer>
      );
    }
    switch (printType) {
      case "picklist":
        return await renderPicklist({
          printerWidth,
          orderTokenDetails,
          orderId,
          pickerName,
          baseOrderResponse,
          date,
          orderItems,
          totalQuantity,
          orgConfig,
        });
      case "invoice":
      case "credit-note":
        return await renderPrintContents();
      case "credit-settlement":
        return await renderCreditSettlement({
          printerWidth,
          retailDetails,
          settlementData,
          date,
        });
      case "report":
        return await renderReport({
          printerWidth,
          sessionData,
        });
      case "end-report":
        return await renderProduct({
          printerWidth,
          productData,
        });
      default:
        return await renderPrintContents();
    }
  };

  const printSerial = async () => {
    // if (!portData) {
    //   await openPort();
    // }
    try {
      const prevPort = await navigator.serial.getPorts();
      const port = prevPort[0]?.readable
        ? prevPort[0]
        : await window.navigator.serial.requestPort();
      prevPort[0]?.readable
        ? console.log("Port already open")
        : await port.open({ baudRate: 115200 });
      // if (!prevPort[0]?.readable) {
      //   const port = await window.navigator.serial.requestPort();
      //   await port.open({ baudRate: 115200 });
      //   setPortData(port);
      // }

      const data = await billData();

      const writer = port.writable?.getWriter();
      // const data = [
      //   0x48, 0x65, 0x6c, 0x6c, 0x6f, 0x20, // 'Hello'
      //   0x77, 0x6f, 0x72, 0x6c, 0x64, 0x0a, // 'world'

      //   0x0a, // New line
      //   //cut paper

      //   0x1b, 0x69, 0x0a, // Cut paper
      //   // 0x1b, 0x40, // Cut paper
      // ]
      if (writer != null) {
        await writer.write(new Uint8Array(data));
        writer.releaseLock();
      }
    } catch (error) {
      console.log(error);
      setIsError(true);
    } finally {
      localStorage.removeItem("CartId");
    }
  };

  const printBluetooth = async () => {
    try {
      const data = await billData();

      const printData = new Uint8Array(data);
      const CHUNK_SIZE = 512;

      if (deviceType === "android") {
        emit({ type: "connectDevice", data: { billData: printData } });
        return;
      }

      if (!bluetoothDevice) {
        bluetoothDevice = await navigator.bluetooth.requestDevice({
          filters: [{ namePrefix: "MPT-II" }],
          optionalServices: ["000018f0-0000-1000-8000-00805f9b34fb"],
        });
      } else if (!bluetoothDevice.gatt.connected) {
        await bluetoothDevice.gatt.connect();
      }
      dispatch(setBluetoothDevice(bluetoothDevice));

      let server;
      try {
        server = await bluetoothDevice.gatt.connect();
      } catch (err) {
        console.error("Error connecting to GATT server: ", err);
        setIsError(true);
        return;
      }

      const service = await server.getPrimaryService("000018f0-0000-1000-8000-00805f9b34fb");
      const characteristic = await service.getCharacteristic(
        "00002af1-0000-1000-8000-00805f9b34fb"
      );

      for (let offset = 0; offset < printData.byteLength; offset += CHUNK_SIZE) {
        const chunk = printData.slice(offset, offset + CHUNK_SIZE);
        await characteristic.writeValueWithoutResponse(chunk);
      }

      setTimeout(
        () => {
          if (bluetoothDevice?.gatt?.connected) {
            bluetoothDevice.gatt.disconnect();
          }
        },
        5 * 60 * 1000
      );

      if (reprint) {
        const metaData = {
          orderId: orderId,
          amount: baseOrderResponse?.amountPaid,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_RECEIPT_REPRINT });
      }
    } catch (error) {
      setIsError(true);
    } finally {
      setIsPrinting(false);
    }
  };

  // const printUSB = async (drawerOpen = false, shouldTestPrint = false, template, charsPerLine) => {

  //   try {
  //     const data = shouldTestPrint
  //       ? await testPrint(template, charsPerLine)
  //       : await billData(drawerOpen);

  //     const findOpenedDevice = async () => {
  //       const devices = await navigator.usb.getDevices();
  //       return devices.find((d) => d.opened);
  //     };
  //     const openedDevice = await findOpenedDevice();
  //     if (!usbDevice) {
  //       const data = await getPrinterIds();
  //       const ids = data?.data?.peripheralList?.map((id) => ({ vendorId: Number(id) }));
  //       usbDevice =
  //         openedDevice ||
  //         (await navigator.usb.requestDevice({
  //           filters: ids,
  //         }));
  //     }
  //     !openedDevice && (await usbDevice.open());
  //     dispatch(setUSBDevice(usbDevice));
  //     if (usbDevice.configuration === null) {
  //       await usbDevice.selectConfiguration(1);
  //     }
  //     await usbDevice.claimInterface(usbDevice.configuration.interfaces[0].interfaceNumber);
  //     await usbDevice.transferOut(
  //       usbDevice.configuration.interfaces[0].alternate.endpoints.find(
  //         (obj) => obj.direction === "out"
  //       ).endpointNumber,
  //       data
  //     );
  //     if (reprint) {
  //       const metaData = {
  //         orderId: orderId,
  //         amount: baseOrderResponse?.amountPaid,
  //       };
  //       eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_RECEIPT_REPRINT });
  //         if (window.printCompleteCallback) {
  //       window.printCompleteCallback();
  //       window.printCompleteCallback = null;
  //     }
  //     }
  //   } catch (error) {
  //      setIsError(true);
  //     // Call error callback if it exists
  //     if (window.printErrorCallback) {
  //       window.printErrorCallback();
  //       window.printErrorCallback = null; // Clean up
  //     }
  //   } finally {
  //     setIsPrinting(false);
  //     if (drawerOpen || reprint) return;

  //   }
  // };

  // Show the browser USB device picker, then persist the selection to Redux + localStorage.
  const pickUSBDevice = async () => {
    // Try to get list of supported printer vendors
    let filters = [];
    try {
      const printerData = await getPrinterIds();
      const vendorIds = printerData?.data?.peripheralList?.map((id) => Number(id)) || [];
      filters = vendorIds.map((id) => ({ vendorId: id }));
    } catch (error) {
      // ignore — fallback below
    }
    // requestDevice({filters:[]}) throws TypeError; always need at least one filter
    if (filters.length === 0) filters = [{ classCode: 7 }];

    // Show the printer picker
    const device = await navigator.usb.requestDevice({ filters });
    dispatch(setUSBDevice(device));

    // Save printer device info to localStorage so it persists across page reloads
    localStorage.setItem(
      "savedUSBPrinterDevice",
      JSON.stringify({
        vendorId: device.vendorId,
        productId: device.productId,
      })
    );
    return device;
  };

  // Forget the currently cached printer (e.g. after it got disconnected) so the next
  // print prompts the picker again.
  const clearUSBDevice = () => {
    dispatch(setUSBDevice(null));
    localStorage.removeItem("savedUSBPrinterDevice");
  };

  // Open/claim the device and send the bytes. Throws if the device is unreachable
  // (unplugged, powered off, etc.).
  const writeToUSBDevice = async (device, data) => {
    if (!device.opened) await device.open();
    if (device.configuration === null) {
      await device.selectConfiguration(1);
    }
    await device.claimInterface(device.configuration.interfaces[0].interfaceNumber);
    await device.transferOut(
      device.configuration.interfaces[0].alternate.endpoints.find(
        (obj) => obj.direction === "out"
      ).endpointNumber,
      data
    );
  };

  const printUSB = async (
    drawerOpen = false,
    shouldTestPrint = false,
    template,
    charsPerLine,
    forcePickDevice = false
  ) => {
    try {
      let deviceToUse = usbDevice; // Get current device from Redux
      // Tracks whether the device was chosen via the picker in this call. When it was,
      // a write failure should NOT re-prompt (the user just picked it) — only cached
      // devices get the reselect-on-failure treatment.
      let pickedFromPicker = false;

      // If no device in Redux, try to restore from localStorage
      if (!deviceToUse && !forcePickDevice) {
        try {
          const savedPrinterInfo = localStorage.getItem("savedUSBPrinterDevice");
          if (savedPrinterInfo) {
            const { vendorId, productId } = JSON.parse(savedPrinterInfo);

            // Try to get the previously connected device from already-paired devices
            try {
              const devices = await navigator.usb.getDevices();
              const savedDevice = devices.find(
                (d) => d.vendorId === vendorId && d.productId === productId
              );

              if (savedDevice) {
                deviceToUse = savedDevice;
                dispatch(setUSBDevice(savedDevice));
              }
            } catch (getDevicesError) {
            }
          }
        } catch (error) {
        }
      }

      // If still no device, ask for device selection
      if (!deviceToUse || forcePickDevice) {
        deviceToUse = await pickUSBDevice();
        pickedFromPicker = true;
      }
      // If device exists in Redux, use it directly (don't ask again)

      const data = shouldTestPrint
        ? await testPrint(template, charsPerLine)
        : await billData(drawerOpen);

      try {
        await writeToUSBDevice(deviceToUse, data);
      } catch (writeError) {
        // The write failed. If we were using a cached device (not one the user just
        // picked), it most likely got disconnected. Forget it and re-open the picker
        // so the user can reconnect / reselect a printer, then retry once.
        if (pickedFromPicker) throw writeError;
        clearUSBDevice();
        deviceToUse = await pickUSBDevice();
        await writeToUSBDevice(deviceToUse, data);
      }

      // CALLBACK FIX: Move this outside the reprint condition
      // Call success callback if it exists
      if (window.printCompleteCallback) {
        window.printCompleteCallback();
        window.printCompleteCallback = null;
      }

      if (reprint) {
        const metaData = {
          orderId: orderId,
          amount: baseOrderResponse?.amountPaid,
        };
        eventTracker({ metaData, eventType: eventTrackerConstant.ORDER_RECEIPT_REPRINT });
      }
    } catch (error) {
      setIsError(true);
      if (window.printErrorCallback) {
        window.printErrorCallback();
        window.printErrorCallback = null;
      }
      throw error;
    } finally {
      setIsPrinting(false);
      if (drawerOpen || reprint) return;
    }
  };

  const testPrint = async (template, charsPerLine) => {
    let renderData = null;
    const baseOrderResponseDetails = {
      orderId: "O250417397",
      cancelReason: null,
      returnId: null,
      offlineOrderId: null,
      offlineInvoiceId: null,
      orderConnectivityType: null,
      purchaseDescValue: null,
      fillRateFrom: "1",
      deliveryType: "IN_STORE",
      roundOff: -0.5,
      sessionId: null,
      updatedBy: "Mohtashim",
      numberOfReturnedItems: null,
      totalReturnedQuantity: null,
      shipmentId: null,
      poNumber: null,
      returnCreatedBy: null,
      returnUpdatedBy: null,
      poDate: null,
      paymentDueOn: null,
      poValue: null,
      store: null,
      paymentLink: null,
      orderType: "POS_ORDER",
      outstandingAmount: 0,
      amountPaid: 158,
      licenseName: "test",
      refund: null,
      invoiceId: "OI250417254",
      cartId: "CART02870",
      customerName: "WALK-IN",
      shipmentDate: null,
      shipmentType: null,
      additionalExpenses: 0,
      fulfilmentTime: null,
      customerId: null,
      fillRate: "0",
      paymentTime: null,
      mobileNumber: null,
      appliedCoupon: null,
      licenseId: "LIC000044",
      numberOfLineItems: 1,
      machineCode: "CASH",
      tender: "158",
      balance: "0",
      sourceId: "RET_39",
      sourceLocationId: "RLC_40",
      destinationId: "RET_39",
      destinationLocationId: "RLC_40",
      orderStatus: "PAID",
      shipmentStatus: null,
      returnStatus: null,
      salesChannel: "POS_ORDER",
      paymentStatus: "COMPLETED",
      fulfilmentStatus: "DELIVERED",
      deliveryMethod: null,
      createdAt: "2025-04-17T06:44:17.969264",
      updatedByName: "Mohtashim",
      updatedAt: "2025-04-17T06:44:17.969277",
      loggedInUserName: null,
      loggedInUserId: "d4dc31be52c.d76b675f981d684f2be0a04cd1cfd05d",
      orderItemList: [
        {
          orderItemId: "OI250417658",
          orgId: null,
          orderId: "O250417397",
          customerId: null,
          vendorId: null,
          quantityOrdered: null,
          deliveryTime: null,
          locationId: "RLC_40",
          startDate: null,
          endDate: null,
          itemNo: null,
          batches: [],
          fillRate: 0,
          skuCode: null,
          quantityUnits: null,
          expirationDate: null,
          weight: null,
          weightUOM: null,
          frontImage: null,
          volume: null,
          volumeUOM: null,
          mainCategory: "HOMECARE",
          categoryLevel1: "ALL PURPOSE CLEANER",
          categoryLevel2: "",
          quantityBySpecs: "1",
          returnedQuantity: null,
          sellingUnit: "nos",
          weightsAndMeasures: {
            measurement_unit: "PCS",
            net_weight: "1.0",
            gross_weight: "1.0",
            net_content: "1.0",
          },
          voidedBy: null,
          productId: "",
          returnedSubTotal: null,
          gtin: "8901023023842",
          couponValue: 0,
          couponType: "",
          couponProductQuantity: 0,
          productName: "Dummy Product",
          size: null,
          unit: null,
          sellerName: null,
          mrp: 182,
          purchasePrice: 150,
          sellingPrice: 157.5,
          quantity: 1,
          status: null,
          quantityReceived: 1,
          quantityOutstanding: 0,
          lastInward: 0,
          batchNo: "BATCH-01",
          batchNumber: null,
          inwardedBy: null,
          discountPrice: 24.5,
          taxableValue: null,
          finalSalePrice: null,
          subTotal: 157.5,
          productImage: "",
          productGST: null,
          productOtherTax: 0,
          igst: 18,
          cgst: 9,
          sgst: 9,
          hsnCode: "",
          createdBy: null,
          createdDate: "2025-04-17T06:44:17.969264",
          modifiedDate: "2025-04-11T11:18:21.753722",
          modifiedBy: null,
          buyXGetYFound: false,
          offerValue: 0,
          isOfferAvailable: false,
          offerApplied: false,
          offerQuantityNotMet: 0,
          prevSellingPrice: 0,
          igstAmount: 24.03,
          cgstAmount: 12.02,
          sgstAmount: 12.02,
          cess: 0,
          cessAmount: 0,
          quantityFulfilled: null,
        },
      ],
      lineItems: [
        {
          orderItemId: "OI250417658",
          orgId: null,
          orderId: "O250417397",
          customerId: null,
          vendorId: null,
          quantityOrdered: null,
          deliveryTime: null,
          locationId: "RLC_40",
          startDate: null,
          endDate: null,
          itemNo: null,
          batches: [],
          fillRate: 0,
          skuCode: null,
          quantityUnits: null,
          expirationDate: null,
          weight: null,
          weightUOM: null,
          frontImage: null,
          volume: null,
          volumeUOM: null,
          mainCategory: "HOMECARE",
          categoryLevel1: "ALL PURPOSE CLEANER",
          categoryLevel2: "",
          quantityBySpecs: "1",
          returnedQuantity: null,
          sellingUnit: "nos",
          weightsAndMeasures: {
            measurement_unit: "PCS",
            net_weight: "1.0",
            gross_weight: "1.0",
            net_content: "1.0",
          },
          voidedBy: null,
          productId: "",
          returnedSubTotal: null,
          gtin: "8901023023842",
          couponValue: 0,
          couponType: "",
          couponProductQuantity: 0,
          productName: "Dummy Product",
          size: null,
          unit: null,
          sellerName: null,
          mrp: 182,
          purchasePrice: 150,
          sellingPrice: 157.5,
          quantity: 1,
          status: null,
          quantityReceived: 1,
          quantityOutstanding: 0,
          lastInward: 0,
          batchNo: "BATCH-01",
          batchNumber: null,
          inwardedBy: null,
          discountPrice: 24.5,
          taxableValue: null,
          finalSalePrice: null,
          subTotal: 157.5,
          productImage: "",
          productGST: null,
          productOtherTax: 0,
          igst: 18,
          cgst: 9,
          sgst: 9,
          hsnCode: "",
          createdBy: null,
          createdDate: "2025-04-17T06:44:17.969264",
          modifiedDate: "2025-04-11T11:18:21.753722",
          modifiedBy: null,
          buyXGetYFound: false,
          offerValue: 0,
          isOfferAvailable: false,
          offerApplied: false,
          offerQuantityNotMet: 0,
          prevSellingPrice: 0,
          igstAmount: 24.03,
          cgstAmount: 12.02,
          sgstAmount: 12.02,
          cess: 0,
          cessAmount: 0,
          quantityFulfilled: null,
        },
      ],
      returnedItems: null,
      slotId: null,
      cutoffId: null,
      startTime: null,
      endTime: null,
      expectedHours: null,
      expectedDeliveryTime: null,
      orderWithinMinutes: null,
    };
    const baseOrderDetails = {
      appliedCoupon: "null",
      appliedOffer: null,
      couponRefId: "null",
      deliveryCharges: 0,
      offerRefId: null,
      subTotal: 133.47,
      cgst: 12.01,
      sgst: 12.01,
      igst: 24.02,
      tax: 24.02,
      dynamicCouponCode: null,
      handlingCharges: null,
      paymentMode: "ONLINE",
      shippingCharges: null,
      grandTotal: 158,
      paymentMethod: "CASH",
      loyaltyPoints: null,
      earnedPoints: null,
      earnedPointValue: null,
      totalAvailablePoints: null,
      couponValue: 0,
      numberOfCouponApplied: null,
      loyaltyPointsValue: 0,
      couponDiscountUpto: 0,
      totalSavings: 24.5,
      licenseName: "abc",
      payments: [
        {
          amountPaid: 158,
          paymentId: "P250417422",
          orderId: null,
          invoiceId: null,
          paymentMethod: "CASH",
          paymentMode: "ONLINE",
          paymentStatus: "COMPLETED",
          transactionCode: null,
          paymentDate: null,
          paymentMachineId: null,
        },
      ],
      redeemAmount: null,
      dynamicCouponDetails: {
        id: null,
        code: null,
        expiryDate: null,
        validDays: null,
        offerName: null,
        on: null,
        print: false,
      },
      redeemableWalletBalance: null,
    };

    const gstDetails = [
      {
        taxableAmt: 0,
        gstRate: 0,
        cgst: 0,
        sgst: 0,
        cess: 0,
        totalAmt: 0,
        type: "",
      },
      {
        taxableAmt: 0,
        gstRate: 0,
        cgst: 0,
        sgst: 0,
        cess: 0,
        totalAmt: 0,
        type: "",
      },
      {
        taxableAmt: 0,
        gstRate: 0,
        cgst: 0,
        sgst: 0,
        cess: 0,
        totalAmt: 0,
        type: "",
      },
      {
        taxableAmt: 133.48,
        gstRate: 18, // ✅ you had cgst 9 + sgst 9 → so rate is 18
        cgst: 12.01,
        sgst: 12.01,
        cess: 0,
        totalAmt: 157.5,
        type: "9% CGST + 9% SGST Slab",
      },
      {
        taxableAmt: 0,
        gstRate: 0,
        cgst: 0,
        sgst: 0,
        cess: 0,
        totalAmt: 0,
        type: "",
      },
      {
        taxableAmt: 0,
        gstRate: 0,
        cgst: 0,
        sgst: 0,
        cess: 0,
        totalAmt: 0,
        type: "",
      },
      {
        taxableAmt: 0,
        gstRate: 0,
        cgst: 0,
        sgst: 0,
        cess: 0,
        totalAmt: 0,
        type: "",
      },
    ];

    const gst9SlabDetails = [
      {
        orderItemId: "OI250417658",
        orgId: null,
        orderId: "O250417397",
        customerId: null,
        vendorId: null,
        quantityOrdered: null,
        deliveryTime: null,
        locationId: "RLC_40",
        startDate: null,
        endDate: null,
        itemNo: null,
        batches: [],
        fillRate: 0,
        skuCode: null,
        quantityUnits: null,
        expirationDate: null,
        weight: null,
        weightUOM: null,
        frontImage: null,
        volume: null,
        volumeUOM: null,
        mainCategory: "HOMECARE",
        categoryLevel1: "ALL PURPOSE CLEANER",
        categoryLevel2: "",
        quantityBySpecs: "1", // keep as string for padStart
        returnedQuantity: null,
        sellingUnit: "nos",
        weightsAndMeasures: {
          measurement_unit: "PCS",
          net_weight: "1.0",
          gross_weight: "1.0",
          net_content: "1.0",
        },
        voidedBy: null,
        productId: "",
        returnedSubTotal: null,
        gtin: "8901023023842",
        couponValue: 0,
        couponType: "",
        couponProductQuantity: 0,
        productName: "Dummy Product",
        size: null,
        unit: null,
        sellerName: null,
        mrp: 182, // number
        purchasePrice: 150,
        sellingPrice: 157.5,
        quantity: 1,
        status: null,
        quantityReceived: 1,
        quantityOutstanding: 0,
        lastInward: 0,
        batchNo: "BATCH-01",
        batchNumber: null,
        inwardedBy: null,
        discountPrice: 24.5,
        taxableValue: null,
        finalSalePrice: null,
        subTotal: 157.5,
        productImage: "",
        productGST: null,
        productOtherTax: 0,
        igst: 18,
        cgst: 9,
        sgst: 9,

        // 🔑 fix 1: instead of "", set at least "0000"
        hsnCode: "0000",

        createdBy: null,
        createdDate: "2025-04-17T06:44:17.969264",
        modifiedDate: "2025-04-11T11:18:21.753722",
        modifiedBy: null,
        buyXGetYFound: false,
        offerValue: 0,
        isOfferAvailable: false,
        offerApplied: false,
        offerQuantityNotMet: 0,
        prevSellingPrice: 0,
        igstAmount: 24.03,
        cgstAmount: 12.02,
        sgstAmount: 12.02,
        cess: 0,
        cessAmount: 0,
        quantityFulfilled: null,

        // 🔑 fix 2: always define addonProduct (even if empty)
        addonProduct: [],
      },
    ];

    const orgConfigDetails = {
      retailConfigurationId: 277,
      coupons: true,
      loyalty: true,
      displayDiscount: true,
      templateId: "template_001",
      retailId: "RET_39",
      deleted: false,
      odsScreen: true,
      idleTimeout: 900000,
      charactersPerLine: 42,
    };

    const getCurrentDate = () => {
      const options = {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };

      const currentDate = new Date().toLocaleString("en-GB", options);
      return currentDate;
    };

    const orderItemDetails = [
      {
        orderItemId: "OI250421661",
        orgId: null,
        orderId: "O250421400",
        customerId: null,
        vendorId: null,
        quantityOrdered: null,
        deliveryTime: null,
        locationId: "RLC_40",
        startDate: null,
        endDate: null,
        itemNo: null,
        batches: [],
        fillRate: 0,
        skuCode: null,
        quantityUnits: null,
        expirationDate: null,
        weight: null,
        weightUOM: null,
        frontImage: null,
        volume: null,
        volumeUOM: null,
        mainCategory: "HOME CARE",
        categoryLevel1: "",
        categoryLevel2: "",
        quantityBySpecs: "1", // keep string for padStart
        returnedQuantity: null,
        sellingUnit: "nos",
        weightsAndMeasures: {
          measurement_unit: "PCS",
          net_weight: "1.0",
          gross_weight: "1.0",
          net_content: "1.0",
        },
        voidedBy: null,
        productId: "",
        returnedSubTotal: null,
        gtin: "010465",
        couponValue: 0,
        couponType: "",
        couponProductQuantity: 0,
        productName: "Dummy Product",
        size: null,
        unit: null,
        sellerName: null,
        mrp: 50,
        purchasePrice: 30,
        sellingPrice: 39,
        quantity: 1,
        status: null,
        quantityReceived: 1,
        quantityOutstanding: 0,
        lastInward: 0,
        batchNo: "BTX-001",
        batchNumber: null,
        inwardedBy: null,
        discountPrice: 11,
        taxableValue: null,
        finalSalePrice: null,
        subTotal: 39,
        productImage: "",
        productGST: null,
        productOtherTax: 0,
        igst: 0,
        cgst: 0,
        sgst: 0,

        // 🔑 Fix 1: instead of "", make it safe
        hsnCode: "0000",

        createdBy: null,
        createdDate: "2025-04-21T12:53:12.751234",
        modifiedDate: "2025-04-21T12:52:32.022885",
        modifiedBy: null,
        buyXGetYFound: false,
        offerValue: 0,
        isOfferAvailable: false,
        offerApplied: false,
        offerQuantityNotMet: 0,
        prevSellingPrice: 0,
        igstAmount: 0,
        cgstAmount: 0,
        sgstAmount: 0,
        cess: 0,
        cessAmount: 0,
        quantityFulfilled: null,

        // 🔑 Fix 2: always include addonProduct
        addonProduct: [],
      },
    ];
    const noGstDetails = [
      {
        orderItemId: "OI250421661",
        orgId: null,
        orderId: "O250421400",
        customerId: null,
        vendorId: null,
        quantityOrdered: null,
        deliveryTime: null,
        locationId: "RLC_40",
        startDate: null,
        endDate: null,
        itemNo: null,
        batches: [],
        fillRate: 0,
        skuCode: null,
        quantityUnits: null,
        expirationDate: null,
        weight: null,
        weightUOM: null,
        frontImage: null,
        volume: null,
        volumeUOM: null,
        mainCategory: "HOME CARE",
        categoryLevel1: "",
        categoryLevel2: "",
        quantityBySpecs: "1",
        returnedQuantity: null,
        sellingUnit: "nos",
        weightsAndMeasures: {
          measurement_unit: "PCS",
          net_weight: "1.0",
          gross_weight: "1.0",
          net_content: "1.0",
        },
        voidedBy: null,
        productId: "",
        returnedSubTotal: null,
        gtin: "010465",
        couponValue: 0,
        couponType: "",
        couponProductQuantity: 0,
        productName: "KALKANDU (B) 500G",
        size: null,
        unit: null,
        sellerName: null,
        mrp: 50,
        purchasePrice: 30,
        sellingPrice: 39,
        quantity: 1,
        status: null,
        quantityReceived: 1,
        quantityOutstanding: 0,
        lastInward: 0,
        batchNo: "BTX-001",
        batchNumber: null,
        inwardedBy: null,
        discountPrice: 11,
        taxableValue: null,
        finalSalePrice: null,
        subTotal: 39,
        productImage: "",
        productGST: null,
        productOtherTax: 0,
        igst: 0,
        cgst: 0,
        sgst: 0,
        hsnCode: "",
        createdBy: null,
        createdDate: "2025-04-21T12:53:12.751234",
        modifiedDate: "2025-04-21T12:52:32.022885",
        modifiedBy: null,
        buyXGetYFound: false,
        offerValue: 0,
        isOfferAvailable: false,
        offerApplied: false,
        offerQuantityNotMet: 0,
        prevSellingPrice: 0,
        igstAmount: 0,
        cgstAmount: 0,
        sgstAmount: 0,
        cess: 0,
        cessAmount: 0,
        quantityFulfilled: null,
      },
    ];
    const testRetailDetails = getStoredRetailDetails();

    switch (template) {
      case "template_001":
        renderData = await renderTemplate001({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          noGst: [],
          gst2slab: [],
          gst1slab: [],
          gst5slab: [],
          gst6slab: [],
          gst9slab: gst9SlabDetails,
          gst14slab: [],
          freeProducts: [],
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;

      case "template_001_1":
        renderData = await renderTemplate001({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          noGst: [],
          gst2slab: [],
          gst1slab: [],
          gst5slab: [],
          gst6slab: [],
          gst9slab: gst9SlabDetails,
          gst14slab: [],
          freeProducts: [],
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;

      case "template_001_02":
        renderData = await renderTemplate002_02({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          noGst: [],
          gst2slab: [],
          gst1slab: [],
          gst5slab: [],
          gst6slab: [],
          gst9slab: gst9SlabDetails,
          gst14slab: [],
          freeProducts: [],
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;

      case "template_002":
        renderData = await renderTemplate002({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          orderItems: orderItemDetails,
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;
      case "template_002_01":
        renderData = await renderTemplate002_01({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          orderItems: orderItemDetails,
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;
      case "template_003":
        renderData = await renderTemplate003({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          cessItems: [],
          orderItems: orderItemDetails,
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;
      case "template_004":
        renderData = await renderTemplate004({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          noGst: noGstDetails,
          gst2slab: [],
          gst1slab: [],
          gst5slab: [],
          gst6slab: [],
          gst9slab: [],
          gst14slab: [],
          freeProducts: [],
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;
      case "template_005":
        renderData = await renderTemplate005({
          printerWidth: charsPerLine,
          retailDetails: testRetailDetails,
          baseOrderResponse: baseOrderResponseDetails,
          baseDetails: baseOrderDetails,
          gstBreakupDetails: gstDetails,
          cessItems: [],
          noGst: noGstDetails,
          gst2slab: [],
          gst1slab: [],
          gst5slab: [],
          gst6slab: [],
          gst9slab: [],
          gst14slab: [],
          freeProducts: [],
          isB2cOrder: false,
          isDeliveryOrder: false,
          reprint: true,
          orderId: 1234567890,
          invoiceId: 1234567890,
          date: getCurrentDate(),
          totalQuantity: 1,
          orgConfig: orgConfigDetails,
          deliveryAddress: null,
          cashDrawerOpen: false,
          returnId,
          printType: "invoice",
        });
        break;
      default:
        renderData = await renderTemplate001({
          printerWidth,
          retailDetails: testRetailDetails,
          baseOrderResponse,
          baseDetails,
          gstBreakupDetails,
          cessItems,
          noGst,
          gst1slab,
          gst2slab,
          gst5slab,
          gst6slab,
          gst9slab,
          gst14slab,
          freeProducts,
          isB2cOrder,
          isDeliveryOrder,
          reprint,
          orderId,
          invoiceId,
          date,
          totalQuantity,
          orgConfig,
          deliveryAddress,
          cashDrawerOpen,
          returnId,
          printType,
        });
    }

    return await render(renderData);
  };

  useEffect(() => {
    if (isPrinting) {
      fetchDetails(printType, orderId, returnId);
    }
  }, [isPrinting, orderId, returnId, printType]);

  useEffect(() => {
    if (key) {
      let printButton = document.createElement("button");
      printButton.addEventListener("click", function () {
        if (printerConfig?.label === "Bluetooth") {
          printBluetooth();
        } else if (printerConfig?.label === "Serial port") {
          printSerial();
        } else {
          printUSB(false, false, undefined, undefined, forcePickDevice);
        }
      });
      printButton.click();
    }
  }, [key]);

  const startPrint = ({
    orderId,
    drawerOpen = false,
    reprint = false,
    printType = "invoice",
    orderSource = "pos",
    pickerName = "",
    sessionData = null,
    productData = null,
    settlementData = null,
    returnId,
    onPrintComplete = null,
    onPrintError = null,
    skipBill = false,
    skipKot = false,
    forcePick = false,
  } = {}) => {
    const printerConfig = JSON.parse(localStorage.getItem("printerConfig"));
    if (printerConfig?.printer === "TVS") {
      setPrinterWidth(46);
    }
    setIsPrinting(true);
    setDrawerOpen(drawerOpen);
    setReprint(reprint);
    setOrderId(orderId);
    setPrintType(printType);
    setOrderSource(orderSource);
    setPickerName(pickerName);
    setSessionData(sessionData);
    setProductData(productData);
    setSettlementData(settlementData);
    setReturnId(returnId);
    setSkipBill(skipBill);
    setSkipKot(skipKot);
    setForcePickDevice(forcePick);
    if (onPrintComplete) window.printCompleteCallback = onPrintComplete;
    if (onPrintError) window.printErrorCallback = onPrintError;
    if (!!reprint) {
      setCashDrawerOpen(false);
    }
  };

  const openDrawer = () => {
    printUSB(true);
  };

  const wordWrapText = (text, maxChars) => {
    const words = text.split(" ");
    const lines = [];
    let current = "";
    for (const word of words) {
      const candidate = current ? `${current} ${word}` : word;
      if (candidate.length <= maxChars) {
        current = candidate;
      } else {
        if (current) lines.push(current);
        if (word.length > maxChars) {
          let remaining = word;
          while (remaining.length > maxChars) {
            lines.push(remaining.slice(0, maxChars));
            remaining = remaining.slice(maxChars);
          }
          current = remaining;
        } else {
          current = word;
        }
      }
    }
    if (current) lines.push(current);
    return lines;
  };

  // Generates TSPL commands for one label (TVS LP 46 LITE at 203 DPI)
  const generateTSPLLabels = ({
    items,
    customerName,
    token,
    labelWidthMm,
    labelHeightMm,
    gapMm = 2,
    labelsPerRow = 1,
  }) => {
    const DPI = 203;
    const mm2dot = (mm) => Math.round((mm * DPI) / 25.4);

    const singleLabelW = mm2dot(labelWidthMm);
    const labelH = mm2dot(labelHeightMm);
    const colGapDots = mm2dot(gapMm);
    const physicalWidthMm = labelWidthMm * labelsPerRow + gapMm * (labelsPerRow - 1);

    const H_PAD = 10;
    const isSmall = labelH <= mm2dot(25);
    const ROW_GAP = isSmall ? 2 : 4;
    const V_PAD = mm2dot(isSmall ? 2 : 3);

    const cx = (text, charW, colOffset = 0) =>
      Math.max(colOffset + H_PAD, Math.round(colOffset + (singleLabelW - text.length * charW) / 2));

    const FONTS = {
      normal: { font: "2", w: 12, h: 20 },
      big: { font: "3", w: 16, h: 24 },
    };

    const maxChars = (fontW) => Math.floor((singleLabelW - 2 * H_PAD) / fontW);

    const wordWrap = (text, maxLen) => {
      const words = text.split(" ");
      const lines = [];
      let current = "";
      for (let word of words) {
        if ((current + word).length <= maxLen) {
          current += (current ? " " : "") + word;
        } else {
          if (current) lines.push(current);
          current = word;
        }
      }
      if (current) lines.push(current);
      return lines;
    };

    const buildRows = (item) => {
      const rows = [];

      if (customerName) {
        rows.push({
          text: String(customerName).substring(0, maxChars(FONTS.normal.w)),
          ...FONTS.normal,
        });
        rows.push({ text: "--------------------", ...FONTS.normal });
      }

      const productLines = wordWrap(String(item.productName || "Item"), maxChars(FONTS.big.w));
      productLines.slice(0, 2).forEach((line) => {
        rows.push({ text: line, ...FONTS.big });
      });

      if (item.variantName) {
        rows.push({
          text: String(item.variantName).substring(0, maxChars(FONTS.normal.w)),
          ...FONTS.normal,
        });
      }

      return rows;
    };

    const renderSlot = (item, colOffset) => {
      const rows = buildRows(item);
      let y = V_PAD;
      let colCmd = "";
      for (const row of rows) {
        if (y + row.h > labelH - V_PAD) break;
        colCmd += `TEXT ${cx(row.text, row.w, colOffset)},${y},"${row.font}",0,1,1,"${
          row.text
        }"\r\n`;
        y += row.h + ROW_GAP;
      }
      return colCmd;
    };

    // Expand by quantity — print one label per physical unit
    const slots = [];
    for (const item of items) {
      const qty = item.quantity || 1;
      for (let i = 0; i < qty; i++) {
        slots.push(item);
      }
    }

    const colOffsets = Array.from(
      { length: labelsPerRow },
      (_, i) => i * (singleLabelW + colGapDots)
    );

    let cmd = "";

    if (labelsPerRow === 1) {
      for (const slot of slots) {
        cmd += `SIZE ${labelWidthMm} mm,${labelHeightMm} mm\r\n`;
        cmd += `GAP ${gapMm} mm,0 mm\r\n`;
        cmd += `DIRECTION 1\r\n`;
        cmd += `CLS\r\n`;
        cmd += renderSlot(slot, 0);
        cmd += `PRINT 1,1\r\n`;
      }
      return cmd;
    }

    // Multi-column support
    for (let i = 0; i < slots.length; i += labelsPerRow) {
      const strip = slots.slice(i, i + labelsPerRow);

      cmd += `SIZE ${physicalWidthMm} mm,${labelHeightMm} mm\r\n`;
      cmd += `GAP ${gapMm} mm,0 mm\r\n`;
      cmd += `DIRECTION 1\r\n`;
      cmd += `CLS\r\n`;

      strip.forEach((slot, colIdx) => {
        cmd += renderSlot(slot, colOffsets[colIdx]);
      });

      cmd += `PRINT 1,1\r\n`;
    }

    return cmd;
  };

  const printItemLabels = async ({
    items = [],
    customerName = "Walk-in",
    token = "",
    labelWidthMm: widthOverride,
    labelHeightMm: heightOverride,
    gapMm: gapOverride,
    labelsPerRow: labelsPerRow,
  }) => {
    if (!items.length) return;

    const appConfig = JSON.parse(localStorage.getItem("appConfig") || "{}");
    const retailType = localStorage.getItem("retailType");
    const labelConfig = appConfig?.all?.LABEL_PRINTER;

    if (retailType === "GROCERY" || !labelConfig?.flag) {
      return;
    }

    const labelWidthMm = widthOverride ?? labelConfig?.labelWidth ?? 75;
    const labelHeightMm = heightOverride ?? labelConfig?.labelHeight ?? 50;
    const gapMm = gapOverride ?? 2;

    try {
      const allCommands = generateTSPLLabels({
        items,
        customerName,
        token,
        labelWidthMm,
        labelHeightMm,
        gapMm,
        labelsPerRow,
      });

      const encoded = new TextEncoder().encode(allCommands);

      // Always prompt the user to select a label printer
      const data = await getPrinterIds();
      const ids = data?.data?.peripheralList?.map((id) => ({ vendorId: Number(id) })) || [];
      const labelVidRaw = labelConfig?.vendorId;
      if (labelVidRaw) {
        const labelVid =
          typeof labelVidRaw === "string" && labelVidRaw.startsWith("0x")
            ? parseInt(labelVidRaw, 16)
            : Number(labelVidRaw);
        if (!ids.some((f) => f.vendorId === labelVid)) {
          ids.push({ vendorId: labelVid });
        }
      }
      const filters = ids.length > 0 ? [...ids, { classCode: 7 }] : [{ classCode: 7 }];
      const labelDevice = await navigator.usb.requestDevice({ filters });

      if (!labelDevice.opened) await labelDevice.open();
      // Only set in Redux if RMS config is present
      dispatch(setLabelPrinterDevice(labelDevice));

      if (labelDevice.configuration === null) await labelDevice.selectConfiguration(1);

      const labelInterfaceNumber = labelDevice.configuration.interfaces[0].interfaceNumber;
      const labelEndpointNumber = labelDevice.configuration.interfaces[0].alternate.endpoints.find(
        (obj) => obj.direction === "out"
      ).endpointNumber;

      try {
        await labelDevice.releaseInterface(labelInterfaceNumber);
      } catch (_) {}
      await labelDevice.claimInterface(labelInterfaceNumber);

      await labelDevice.transferOut(labelEndpointNumber, encoded);
    } catch (error) {
      setIsError(true);
      throw error;
    }
  };

  // Get the current saved printer device information
  const getSavedPrinter = () => {
    if (usbDevice) {
      return {
        vendorId: usbDevice.vendorId,
        productId: usbDevice.productId,
        deviceName:
          usbDevice.productName || `Printer (${usbDevice.vendorId}:${usbDevice.productId})`,
      };
    }
    return null;
  };

  // Reset the saved printer device - forces user to select a new one on next print
  const resetPrinterDevice = () => {
    dispatch(setUSBDevice(null));
    localStorage.removeItem("savedUSBPrinterDevice");
  };

  return {
    startPrint,
    isPrinting,
    openDrawer,
    isError,
    printUSB,
    printToken,
    printItemLabels,
    getSavedPrinter,
    resetPrinterDevice,
  };
};

export default usePrint;
